import React from 'react';
export function KeyboardIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M7 8H5v2h2V8zm-2 3h2v2H5v-2zm5-3H8v2h2V8zm-2 3h2v2H8v-2zm5-3h-2v2h2V8zm-2 3h2v2h-2v-2zm5-3h-2v2h2V8zm-2 3h2v2h-2v-2zm5 0h-2v2h2v-2zM8 14h8v2H8v-2zm11-6h-2v2h2V8z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5a1 1 0 011-1h20a1 1 0 011 1v14a1 1 0 01-1 1H2a1 1 0 01-1-1V5zm2 13V6h18v12H3z"
  }));
}